import React from "react";
import NavbarDoctorOffice from "../NavbarDoctorOffice";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Input,
  Label,
  CardBody,
  Card,
} from "reactstrap";
import ReactTable from "@dhn/components/molecules/data-table";
import useActions from "./use-actions";
import ModalParametersMedical from "./modals/ModalParametersMedical";
import CardHeaderTabs from "../../../@dhn/components/molecules/card-header-tabs";
import { isEmpty } from "lodash";
import DoctorsOfficePage from "../components/DoctorsOfficePage";

export default function MedicalParameters({
  profile,
  user,
  center,
  dataDoctor,
  history,
}) {
  const [
    { state },
    { onChange, toggle, consultoryParametersLoading, handleActionButtonAdd },
  ] = useActions(dataDoctor, history);
  const { dataConsultoryParameters, optionsSpecialitiesByMedical, activeTab } =
    state;
  return (
    <div className="animated fadeIn">
      <NavbarDoctorOffice
        profile={profile}
        user={user}
        center={center}
        dataDoctor={dataDoctor}
      />
      <ModalParametersMedical
        state={state}
        onChange={onChange}
        toggle={toggle}
      />
      <DoctorsOfficePage icon="fa-sliders" title="Mis Parámetros Médicos">
        <Row form className="d-flex align-items-end">
          <Col md={4}>
            <Label>Médico</Label>
            <Input
              disabled
              value={`${user.firstName} ${user.lastName}`}
            />
          </Col>
          <Col md={3}>
            <Button
              color="primary"
              className="btn-color-primary ml-1"
              onClick={handleActionButtonAdd}
            >
              <i className="fa fa-plus"></i>
              {" Agregar"}
            </Button>
          </Col>
        </Row>
        <Row form className="mt-4">
          <Col md={12}>
            <Card>
              <CardHeaderTabs
                active={activeTab}
                onClick={(item) => onChange("activeTab", item)}
                tabs={optionsSpecialitiesByMedical}
              />
              <CardBody>
                <ReactTable
                  defaultPageSize={15}
                  loading={consultoryParametersLoading}
                  loadingText="Cargando Grupo de Parametros..."
                  noDataText="Lista Grupo de Parametros Vacia"
                  showPagination={!isEmpty(dataConsultoryParameters)}
                  data={dataConsultoryParameters}
                  className="-striped -highlight"
                  columns={
                    isEmpty(dataConsultoryParameters)
                      ? []
                      : [
                          {
                            Header: "Grupo de Parámetros",
                            accessor: "nameParameterGroup",
                          },
                          {
                            Header: "Configurados",
                            className: "text-center",
                            accessor: "amountConfiguration",
                          },
                          {
                            Header: "Opciones",
                            Cell: ({ original: { id } }) => {
                              return (
                                <FormGroup>
                                  <Button
                                    color="secondary"
                                    type="button"
                                    className="btn-color-gray card-header-action"
                                    onClick={() =>
                                      history.push(
                                        `/medical-parameters/edit/${id}`
                                      )
                                    }
                                  >
                                    <i className="fa fa-pencil"></i>
                                    {" Editar"}
                                  </Button>
                                </FormGroup>
                              );
                            },
                          },
                        ]
                  }
                />
              </CardBody>
            </Card>
          </Col>
          <br />
        </Row>
      </DoctorsOfficePage>
    </div>
  );
}
